var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100"},[(_vm.customContent)?_c(_vm.customContent,{tag:"component"}):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }